import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api/auth/forgot-password`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email })
        }
      );

      const data = await response.json();

      if (data.success) {
        setStatus('success');
        setMessage('If an account exists with this email, you will receive a password reset link.');
      } else {
        setStatus('error');
        setMessage(data.error || 'Something went wrong');
      }
    } catch (error) {
      setStatus('error');
      setMessage('An error occurred. Please try again.');
    }
  };

  return (
    <div className="auth-page" style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Container>
        <div className="d-flex justify-content-center">
          <Card style={{ maxWidth: '450px', width: '100%' }}>
            <Card.Body className="p-5">
              <div className="text-center mb-4">
                <h2><span role="img" aria-label="microphone">🎙️</span> EchoBrief</h2>
                <p className="text-muted">Reset your password</p>
              </div>

              {status === 'success' ? (
                <>
                  <Alert variant="success">
                    <Alert.Heading><span role="img" aria-label="email">📧</span> Check your email</Alert.Heading>
                    <p>{message}</p>
                  </Alert>
                  <div className="text-center mt-4">
                    <Link to="/login">
                      <Button variant="outline-primary">Back to Login</Button>
                    </Link>
                  </div>
                </>
              ) : (
                <>
                  {status === 'error' && (
                    <Alert variant="danger" dismissible onClose={() => setStatus('idle')}>
                      {message}
                    </Alert>
                  )}

                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-4">
                      <Form.Label>Email address</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={status === 'loading'}
                      />
                      <Form.Text className="text-muted">
                        We'll send you a link to reset your password.
                      </Form.Text>
                    </Form.Group>

                    <Button 
                      variant="primary" 
                      type="submit" 
                      className="w-100 mb-3"
                      disabled={status === 'loading'}
                    >
                      {status === 'loading' ? (
                        <>
                          <Spinner size="sm" className="me-2" />
                          Sending...
                        </>
                      ) : (
                        'Send Reset Link'
                      )}
                    </Button>
                  </Form>

                  <div className="text-center mt-4">
                    <Link to="/login" className="text-decoration-none">
                      ← Back to Login
                    </Link>
                  </div>
                </>
              )}
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default ForgotPassword;
